import { render, staticRenderFns } from "./NewUserDialog.vue?vue&type=template&id=2c2182b8&scoped=true&"
import script from "./NewUserDialog.vue?vue&type=script&lang=js&"
export * from "./NewUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2182b8",
  null
  
)

export default component.exports